import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Row } from '@chargify/custom-ui-components';
import { useFormatAddress } from '@chargify/address';
import { DetailsRow } from '../DetailsRow';
import { Address } from '../../../models/paymentProfile/types';

export type BillingAddressProps = {
  billingAddress: Address;
};

const BillingAddress = ({ billingAddress }: BillingAddressProps) => {
  const { t } = useTranslation(['subscriptions-manager']);
  const { address, address2, city, state, zip, country } =
    useFormatAddress(billingAddress);

  const addresses = (address || address2) && `${address} ${address2}`;
  const stateAndZip = (state || zip) && `${state} ${zip}`;
  return (
    <Box>
      <Row rowGap={4}>
        <DetailsRow
          label={t('payment_profile.street_name_and_number')}
          value={addresses}
        />
        <DetailsRow label={t('payment_profile.town')} value={city} />
        <DetailsRow
          label={t('payment_profile.state_and_zip_code')}
          value={stateAndZip}
        />
        <DetailsRow label={t('payment_profile.country')} value={country} />
      </Row>
    </Box>
  );
};

export default BillingAddress;
